<div class="kit-container">
			<img class="bumper-image" src="/static/tpdg/home/That-Peking-Duck-Guy-Combined-Logo-Orange.webp">


	<div class="spacer"></div>
<div class="spacer"></div>

	<div class="kit-box whats-in">
		<div class="kit-box-title">Peking Duck Meal Kit<br/></div>
		<span class="kit-box-context">Feeds 4 people</span>
		<hr/>
		<div class="box-contents">
			<div class="box-contents-column">
				1 Whole Peking Duck<br/>
				incl. crispy skin + meat<br/>
				<br/>
				Duck Fat Noodles<br/>
				<br/>
				Duck Bone Broth<br/>
				<br/>
				Seasonal Vegetable
			</div>

			<div class="box-contents-column">
				Shredded Scallion<br/>
				<br/>
				Sliced Cucumber<br/>
				<br/>
				Hoisin Sauce<br/>
				<br/>
				18 Mu Shu Pancakes
			</div>
		</div>
	</div>

<div class="spacer"></div>
<div class="spacer"></div>

	<div class="kit-box ">
		<div class="kit-box-title">How to Eat</div>
			<br/>
			<div class="kit-box-content">
			Lay out one Mu Shu pancake flat, spread a thin layer of hoisin sauce<br/>
			<br/>
			Add a few pieces of duck meat and 1-2 pieces of crispy skin<br/>
			<br/>

			Top with a few slivers or scallion, cucumber<br/>
			<br/>

			Fold the bottom in, then fold the sides in and over<br/>
			<br/>

			Enjoy!
			<br/>
		</div>
	</div>

<div class="spacer"></div>
<div class="spacer"></div>

	<div class="kit-box ">
		<div class="kit-box-title">Reheat Instructions</div>
		<br/>
		<div class="kit-box-content">
			<span class="content-header">Skin</span> <br/><BR/>
			&#9679; Separate the skin from the rest of the duck meat.<br/>
			<br/> 

			&#9679; Preheat Airfry at 300F degrees. Lay duck pieces flat on a tray or foil. Airfry 5 to 7 mins until crispy.<br/>
				<br/>
				<br/>

			<span class="content-header">Meat</span> <br/><BR/>
			&#9679; Arrange the meat on a plate, microwave for 1-2 mins until hot.<br/>
				<br/>
				<br/>

			<span class="content-header">Noodles/Soup</span> <br/><br/>
			&#9679; Place the noodles and soup into a heat safe bowl. Microwave 1 min to 1:30 mins until hot.<br/>
				<br/>
				<br/>

			<span class="content-header">Mushu Pancakes</span> <br/><br/>
			&#9679; Open package and peel apart the wraps (each package should contain 6). 
			<br/>
			<br/>
			&#9679; Arrange on a plate and cover with slightly damp towel, microwave 15 seconds until warm.
			<br/>
		</div>
	</div>
<div class="spacer"></div>

</div>
